export const SSR_USER_SESSION_ID: string = 'ssr-user-session-00000000-0000-0000-0000-000000000000';
